// App.vue
<template>
<div id="app">
    <div v-if="isLoading">
        <blurryLoader />
    </div>
    <template v-else>
        <router-view :baseUrl="baseUrl" :stripeKey="StripeKey" :googleMapsApiKey="googleMapsApiKey" @add-to-cart="addItemToCart" @showChatWindow="showChatWindow">
        </router-view>
        <!-- Old chat widget - commented out, using new blue ChatWidget in dashboard instead -->
        <!-- <ChatWindow :hideIconOn="'checkoutWeightLoss'" /> -->
        <footer-section v-if="reportPage" />
        <HealthInfoConsentModal />
    </template>
</div>
</template>

<script>
import FooterElement from './components/common/footerElement.vue'
// import ChatWindow from './components/chat/chatWindowNew.vue' // Old chat - using new blue ChatWidget
import {
    initializeProducts
} from '@/utils/productData'
import blurryLoader from './components/common/blurryLoader.vue'
import HealthInfoConsentModal from './components/common/HealthInfoConsentModal.vue'

const apiEndpoint = process.env.VUE_APP_API_ENDPOINT;
const StripeKey = process.env.VUE_APP_STRIPE_KEY;
const GoogleMapsApiKey = process.env.VUE_APP_GOOGLE_KEY;

const CACHE_KEY = 'cached_products';
const CACHE_DURATION = 24 * 60 * 60 * 1000;

export default {
    name: 'App',
    components: {
        'footer-section': FooterElement,
        // ChatWindow, // Old chat - using new blue ChatWidget
        blurryLoader,
        HealthInfoConsentModal
    },
    data() {
        return {
            baseUrl: `${apiEndpoint}`,
            StripeKey: StripeKey,
            googleMapsApiKey: GoogleMapsApiKey,
            isLoading: true
        }
    },
    created() {
        this.initializeApp();
        this.$store.dispatch('captureTrackingData');

        setTimeout(() => {
            this.$store.dispatch('initTheme');
        }, 500);
    },
    computed: {
        isLoggedin() {
            return this.$store.getters.isAuthenticated;
        },
        isNotFormPage() {
            let rname = this.$route.name;
            return !['FormLoader', 'WeightLossFlowTwoHome', 'reportPage', 'choosePlan', 'leadDisqualified', 'ResetPassword', 'LoginPage', 'ForgotPassword'].includes(rname);
        },
        reportPage() {
            let rname = this.$route.name;
            // Hide footer on dashboard pages
            if (this.$route.path.startsWith('/home')) {
                return false;
            }
            // The members free NAD+ page draws its own footer.
            return !['CareCalendar', 'Calendar','CheckoutFlowNew', 'FreeNadClaim', 'FreeNadUpgrade'].includes(rname);
        }
    },
    mounted() {
        this.getTrackingData();
    },
    methods: {
        getTrackingData() {
            try{
                const getCookie = (name) => {
                const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
                return match ? decodeURIComponent(match[2]) : '';
            };

            // Match any cookie name that starts with "ef_tid"
            const findEverflowTid = () => {
                const cookies = document.cookie.split(';').map(c => c.trim());
                for (const cookie of cookies) {
                    const [key, value] = cookie.split('=');
                    if (key && key.startsWith('ef_tid')) {
                        return decodeURIComponent(value);
                    }
                }
                return '';
            };

            let tid =  getCookie('tid') || findEverflowTid();

            if (!tid && window.EF) {
                try {
                    const offerId = window.EF.urlParameter('oid') || 1;
                    tid = window.EF.getTransactionId(offerId);
                    if (tid) {
                        document.cookie = `tid=${tid}; path=/; domain=.rxpros.com; Secure; SameSite=None; max-age=2592000`;
                    }
                } catch (error) {
                    tid = "error generating tid";
                }
            }
            //window.location.reload()
            }catch(error){
                console.log(error)
            }
            
        },
        showChatWindow() {
            if (window.GuestChatWidget && typeof window.GuestChatWidget.open === 'function') {
                try {
                    window.GuestChatWidget.open();
                } catch {
                    // silent
                }
            }
        },
        addItemToCart(item) {
            this.$store.dispatch('addToCart', item);
        },
        async initializeApp() {
            try {
                await this.loadProducts();
            } catch (error) {
                console.error('Failed to initialize app:', error);
            }
        },
        async loadProducts() {
            try {
                const cachedData = localStorage.getItem(CACHE_KEY);

                if (cachedData) {
                    const {
                        timestamp,
                        products
                    } = JSON.parse(cachedData);

                    if (Date.now() - timestamp < CACHE_DURATION) {
                        initializeProducts(products);
                        this.isLoading = false;
                        return products;
                    }
                }

                const response = await this.$axios.get(`${this.baseUrl}/api/get-all-products`);

                if (response.status !== 200) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const products = response.data.products;

                localStorage.setItem(CACHE_KEY, JSON.stringify({
                    timestamp: Date.now(),
                    products
                }));

                initializeProducts(products);
                this.isLoading = false;
                return products;
            } catch (error) {
                console.error('Error fetching/caching products:', error);

                const cachedData = localStorage.getItem(CACHE_KEY);
                if (cachedData) {
                    const {
                        products
                    } = JSON.parse(cachedData);
                    initializeProducts(products);
                    this.isLoading = false;
                    return products;
                }

                this.isLoading = false;
                throw error;
            }
        }
    }
}
</script>

<style scoped>
.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.2rem;
    z-index: 9999;
}
</style>

<style>
/* Sticky footer - ensures footer stays at bottom on login page */
#app {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
}

#app > .login-section {
    flex: 1;
}
</style>
